const botPageContent = {
  "afterparty-groovy": {
    categories: ["Music", "Entertainment"],
    bestFor: "Communities that want continuous music, playlists, and a shared listening experience.",
  },
  versa: {
    categories: ["Moderation", "Utility", "Automation"],
    bestFor: "Growing communities that need structured moderation, roles, automation, and analytics in one bot.",
  },
  verifybot: {
    categories: ["Moderation", "Verification", "Security"],
    bestFor: "Age-gated and community-focused servers that need reliable verification and trusted-access controls.",
  },
  "voice-maestro": {
    categories: ["Utility", "Voice Automation"],
    bestFor: "Servers that want temporary voice rooms created automatically as members need them.",
    docsUrl: "https://voicemaestro.xyz/",
  },
  "lofi-vibes": {
    categories: ["Music", "Entertainment"],
    bestFor: "Study rooms, relaxed communities, and members who want curated lofi music around the clock.",
  },
  novapulse: {
    categories: ["Moderation", "Verification", "Security", "Automation"],
    bestFor: "Community servers, gaming communities, and growing Discord servers.",
  },
};

export default botPageContent;
